import { onUnmounted, reactive, ref } from 'vue'

export function useResendCooldown(seconds = 60) {
  const secondsLeft = ref(0)
  let timer = null

  const clearTimer = () => {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }

  const startCooldown = (duration = seconds) => {
    clearTimer()
    secondsLeft.value = Math.max(0, Math.ceil(duration))

    if (secondsLeft.value === 0) return

    timer = setInterval(() => {
      secondsLeft.value -= 1
      if (secondsLeft.value <= 0) {
        secondsLeft.value = 0
        clearTimer()
      }
    }, 1000)
  }

  onUnmounted(clearTimer)

  return reactive({
    secondsLeft,
    get isCoolingDown() {
      return secondsLeft.value > 0
    },
    get formattedCountdown() {
      const m = Math.floor(secondsLeft.value / 60)
      const s = secondsLeft.value % 60
      return `${m}:${String(s).padStart(2, '0')}`
    },
    startCooldown,
  })
}
